import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import {
	LoginFailed,
	LoginProcessed,
	LoginRequested,
	SessionRefreshed
} from "../actions/user.actions";
import { UserState } from "../models/user-state";

const initialState: UserState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(LoginRequested, () => ({ ...initialState })),
	on(LoginProcessed, (state, { userState }) => ({
		...state,
		...userState
	})),
	on(LoginFailed, (state, action) => ({ ...initialState, error: action.error, loading: false })),
	on(SessionRefreshed, (state, action) => _.merge(_.cloneDeep(state), action.userState))
);

export function userReducer(state: UserState | undefined, action: Action): UserState {
	return reducer(state, action);
}
